import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("order", ["restaurantDetails"])
  },
  methods: {
    async addRazorpayScript() {
      if (window.Razorpay && typeof window.Razorpay === "function") return;
      await this.addScript({
        src: "https://checkout.razorpay.com/v1/checkout.js",
        async: true,
        defer: true,
        crossorigin: "anonymous"
      });
    },

    proceedRazorpayPayment(options, successCallback, failureCallback) {
      if (this.isAndroid()) {
        // For Android App
        Android.initRazorpayPayment(JSON.stringify(options));
        window.razorpayPaymentSuccess = successCallback;
        window.razorpayPaymentFailure = failureCallback;
      } else {
        options.handler = function (response) {
          successCallback(response);
        }.bind(this);
        var rzp1 = new Razorpay(options);
        rzp1.on(
          "payment.failed",
          function (response) {
            failureCallback(response);
          }.bind(this)
        );
        rzp1.open();
      }
    }
  }
};
